import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SpecialtyDropdown from "../shared//SpecialtyDropdown";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import { stateCodeArray } from "../../services/fakeDB/ListUser";
import $ from "jquery";

const SearchUser = ({ userSearchObj }) => {
  const { userToken, sharedObject, SetSharedObject, userRole, userSession } =
    useUserStore((state) => ({
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
      userRole: state.userRole,
      userSession: state.userSession,
    }));
  const navigate = useNavigate();
  const [processing, SetProcessing] = useState(false);
  const [answers, setAnswers] = useState();
  const [custObject, SetCustObject] = useState([]);
  const [orgObj, SetOrgObj] = useState([]);
  const [vendorId, SetVendorId] = useState();

  const setAnswer = async (questionId, answer, chck) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  const SpecialFormFields = async (val) => {};
  useEffect(() => {
    if (userRole === "SES ADMINISTRATOR") {
      SetVendorId(userSession.vendor_id);
      CustomerIdSet(userSession.vendor_id);
    } else {
      const temp = [];
      for (let el of sharedObject.getOrgsObj) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObj(temp);
    }
    const temp = [];
    if (sharedObject.vendorsObj.length > 0) {
      for (let el of sharedObject.vendorsObj) {
        el.show = true;
        temp.push(el);
      }
    }

    SetCustObject(temp);
    SetSharedObject("specialties", {});
  }, []);

  const CustomerIdSet = async (el) => {
    if (el === "") {
      SetOrgObj([]);
      return;
    }
    SetProcessing(true);
    let call = "/users/GetOrgsByCustID?vendorID=" + parseInt(el);
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      const temp = [];
      for (let el of res.data.data) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObj(temp);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  const filterVendors = (val) => {
    const tmp = [];
    if (val.length > 1) {
      custObject?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      custObject?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetCustObject(tmp);
  };
  const filterOrganiations = (val) => {
    const tmp = [];
    if (val.length > 1) {
      orgObj?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      orgObj?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetOrgObj(tmp);
  };
  const AdvSearch = async () => {
    let o = {
      ...answers,
      SystemCreated: "Portal_Upload",
      SpecializationCode: sharedObject?.specialties?.code
        ? sharedObject?.specialties?.code
        : null,
      SpecializationId: sharedObject?.specialties?.id
        ? sharedObject?.specialties?.id
        : null,
    };
    userSearchObj(o);
  };
  const handleOrg = async (vl) => {
    let val = vl.split("-");
    let obj = {
      ...answers,
      ["OrganizationId"]: parseInt(val[0]),
      ["OrganizationName"]: val[1],
    };
    await setAnswers(obj);
  };
  return (
    <div>
      <div
        className="modal fade"
        id="advUserSearchModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="AdvancedUserSearch"
        aria-hidden="false"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title spacer-inline" id="myModalLabel">
                {" "}
                Advanced Search{" "}
              </div>
              <button
                type="button"
                className="close"
                aria-label="Close"
                data-dismiss="modal"
              >
                {" "}
                <span aria-hidden="false">&times;</span>{" "}
              </button>
            </div>

            <form>
              <div className="modal-body">
                <div className="modal-content-body container">
                  {/*Customers*/}
                  {userRole !== "ADMINISTRATOR" ? null : (
                    <>
                      {userRole !== "SES ADMINISTRATOR" ? null : (
                        <>
                          <div className="field-wrapper">
                            <label for="VendorId" className="sp-margin3">
                              {" "}
                              Customer{" "}
                            </label>
                            <span className="filter-container dg-clr">
                              <input
                                className="form-control filter-sm"
                                type="search"
                                placeholder="Filter"
                                onChange={(el) => {
                                  filterVendors(el.target.value);
                                }}
                              />
                            </span>
                            <select
                              className="form-control"
                              id="VendorId"
                              name="VendorId"
                              value={answers?.VendorId}
                              size="4"
                              onChange={(el) => {
                                CustomerIdSet(el.target.value);
                                setAnswer(
                                  "VendorId",
                                  parseInt(el.target.value)
                                );
                              }}
                            >
                              <option value={0}>Select Customer</option>
                              {custObject?.map((el) => {
                                if (el.show)
                                  return (
                                    <option key={el.id} value={el.id}>
                                      {el.name}
                                    </option>
                                  );
                              })}
                            </select>
                          </div>
                        </>
                      )}
                      <div className="field-wrapper">
                        <label for="Org" className="sp-margin3">
                          Organization
                        </label>
                        <span className="filter-container dg-clr">
                          <input
                            className="form-control filter-sm"
                            type="search"
                            placeholder="Filter"
                            onChange={(el) =>
                              filterOrganiations(el.target.value)
                            }
                          />
                        </span>
                        {orgObj.length > 0 ? (
                          <select
                            className="form-control"
                            name="Organization"
                            onChange={(el) => {
                              handleOrg(el.target.value);
                            }}
                            value={answers?.Organization}
                            size="4"
                          >
                            <option value={""}>Select Organization</option>
                            {orgObj?.map((el) => {
                              if (el.show)
                                return (
                                  <option
                                    key={el.id}
                                    value={`${el.id}-${el.name}`}
                                  >
                                    {el.name}
                                  </option>
                                );
                            })}
                          </select>
                        ) : (
                          <div className="watermark-wrapper">No Results</div>
                        )}
                      </div>{" "}
                    </>
                  )}
                  {/*Username*/}
                  <div className="field-wrapper">
                    <label for="UserName">Username</label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={(el) => {
                        setAnswer("UserName", el.target.value);
                      }}
                      value={answers?.UserName}
                    />
                  </div>
                  {/*First or Last Name*/}
                  <div className="field-wrapper spacer-margin5 spacer-inline w-md2 v-top">
                    <label for="FirstName">First Name</label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={(el) => {
                        setAnswer("FirstName", el.target.value);
                      }}
                      value={answers?.FirstName}
                    />
                  </div>
                  <div className="field-wrapper spacer-inline w-md2 v-top">
                    <label for="LastName">Last Name</label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={(el) => {
                        setAnswer("LastName", el.target.value);
                      }}
                      value={answers?.LastName}
                    />
                  </div>
                  {/*Email*/}
                  <div className="field-wrapper">
                    <label for="UserName">Email</label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={(el) => {
                        setAnswer("ContactEmail", el.target.value);
                      }}
                      value={answers?.ContactEmail}
                    />
                  </div>
                  {/*City*/}
                  <div className="field-wrapper">
                    <label for="city">City</label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={(el) => {
                        setAnswer("City", el.target.value);
                      }}
                      value={answers?.City}
                    />
                  </div>
                  {/*State and Zip*/}
                  <div className="field-wrapper">
                    <div className="field-box1 field-ext">
                      <label for="state">State</label>
                      <select
                        className="form-control"
                        name="state"
                        onChange={(el) => {
                          setAnswer("State", el.target.value);
                        }}
                        value={answers?.State}
                      >
                        <option value="">Select</option>
                        {stateCodeArray.map((el) => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="field-box1 field-ext">
                      <label for="Zip">Zip</label>
                      <input
                        className="form-control"
                        onChange={(el) => {
                          setAnswer("Zip", parseInt(el.target.value));
                        }}
                        value={answers?.Zip}
                      />
                    </div>
                  </div>

                  <div className=" field-wrapper">
                    <div id="accordion" className="accordion">
                      <div className="card mb-0">
                        <div
                          className="card-header collapsed"
                          data-toggle="collapse"
                          data-parent="#accordion"
                          href="#collapseThree"
                        ></div>
                        <div
                          id="collapseThree"
                          className="collapse"
                          data-parent="#accordion"
                        >
                          <div className="field-wrapper spacer-margin4">
                            <div className="ctr sub-titles spacer-margin7 blk-clr">
                              {" "}
                              Specialty{" "}
                            </div>
                            <div className="text-reg spacer-margin7">
                              All three criteria must be selected to search by
                              Specialty.
                            </div>
                            {/*Specialty Component*/}
                            <SpecialtyDropdown
                              SpecialFormFields={SpecialFormFields}
                              codes={sharedObject.speciality?.codes}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(el) => AdvSearch()}
                >
                  {" "}
                  Search{" "}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  data-dismiss="modal"
                >
                  {" "}
                  Cancel{" "}
                </button>
              </div>
            </form>
            {processing ? <div className="loading"></div> : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchUser;
